import { ComponentChangesToIgnore as e, entityAndComponentStore as t } from "../stores/entities-store/useEntityAndComponentStore.js";
import "../stores/index.js";
import { useEffect as n, useRef as r, useSyncExternalStore as i } from "react";
//#region src/lib/hooks/useComponentType.ts
var a = (e) => {
	let t = r(null), a = () => (t.current ||= o(e), t.current), s = i(a().subscribe, a().getSnapshot);
	return n(() => () => {
		t.current && t.current.destroy();
	}, []), s;
}, o = (n) => {
	let r = /* @__PURE__ */ new Map(), i = [], a = /* @__PURE__ */ new Set(), o = () => i, s = (e) => (a.add(e), () => a.delete(e)), c = (e) => {
		i = e, a.forEach((e) => e());
	}, l = ({ dirtyProperties: t }) => {
		t.some((t) => !e.has(t)) && c(Array.from(r.values()));
	}, u = t.subscribe((e) => e.components, (e) => {
		let t = e.filter((e) => e.type === n).reduce((e, t) => e.set(t.getUniqueId(), t), /* @__PURE__ */ new Map()), i = !1;
		r.forEach((e, n) => {
			t.has(n) || (e.events.off("update", l), r.delete(n), i = !0);
		}), t.forEach((e, t) => {
			r.has(t) || (e.events.on("update", l), r.set(t, e), i = !0);
		}), i && c(Array.from(r.values()));
	}, { fireImmediately: !0 });
	return {
		getSnapshot: o,
		subscribe: s,
		destroy: () => {
			u(), a.clear(), r.clear(), i = [];
		}
	};
};
//#endregion
export { a as useComponentType };
